export const DEALER_DISCOUNTS_CORE_NAME = 'DEALER_DISCOUNTS';
export const DEALER_DISCOUNTS_SLIDE_OUT_TOGGLE = `${DEALER_DISCOUNTS_CORE_NAME}_SLIDE_OUT_TOGGLE`;

export const APPLY_DEALER_DISCOUNTS = `APPLY_${DEALER_DISCOUNTS_CORE_NAME}`;
export const APPLY_DEALER_DISCOUNTS_SUCCESS = `APPLY_${DEALER_DISCOUNTS_CORE_NAME}_SUCCESS`;
export const APPLY_DEALER_DISCOUNTS_FAILURE = `APPLY_${DEALER_DISCOUNTS_CORE_NAME}_FAILURE`;
